import {Space} from "antd";
import {CreateKycSteps} from "../steps";

export function CreateKycMultiFormStepHeader() {
  return (
    <Space size={24} direction="vertical" style={{display: "flex"}}>
      <p>Verify your identity to ensure account safety and legal compliance</p>
      <CreateKycSteps />
    </Space>
  );
}
